const { default: axios } = require("axios");

const loadBusiness = () => {

  const response  = axios({
    url:"/businesses",
    method:"GET",
    headers: {
      "Accept-Language": "en-US,en;q=0.8",
    }
  }).then((response) => {
    if (response.data)  {
      return response.data;
    }else{
      return response.data.message
    }
  })
  return response

}

const saveBusinessData = (formData) => {
  const response  = axios({
    url:"businesses/add",
    method:"POST",
    data:formData,
    headers: {
      "Accept-Language": "en-US,en;q=0.8",
    }
  }).then((response) => {
    return response.data;
  }).catch((error)=>{
    return error
  })
  return response
}

const getBusinessBranches = (businessId) => {
  const response = axios({
    url: "/businesses-branches/" + businessId,
    method: "GET",
    headers: {
      "Accept-Language": "en-US,en;q=0.8",
    }
  }).then((response)=>{
    return response.data;
  }).catch((error)=>{
    return error
  })
  return response;
}

const businessService = {
  loadBusiness,
  saveBusinessData,
  getBusinessBranches
}

export default businessService